import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from "vant";
// import './permission'
import "amfe-flexible";
import "vant/lib/index.css";
import "@/assets/styles/main.css";
import { install, TextEllipsis } from "heyui";

import qs from "qs";
import { collect, getCollectName } from "@/utils/collect";

Vue.prototype.$qs = qs;
Vue.prototype.$collect = collect;
Vue.prototype.$getCollectName = getCollectName;

Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(install, { components: { TextEllipsis } });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
